import i18n from 'modules/core/lib/i18n'

export const getParticipantsLabel = (strategy: string | undefined | null): string => {
  switch (strategy) {
    case 'everyone':
      return i18n.t('surveys.configuration.participants.options.everyone_with_external_users.label')
    case 'all_employees':
      return i18n.t('surveys.configuration.participants.options.all_employees.label')
    case 'employees':
      return i18n.t('surveys.configuration.participants.options.employees.label')
    case 'managers':
      return i18n.t('surveys.configuration.participants.options.managers.label')
    case 'teams':
      return i18n.t('surveys.configuration.participants.options.teams.label')
    case 'locations':
      return i18n.t('surveys.configuration.participants.options.locations.label')
    case 'legal_entities':
      return i18n.t('surveys.configuration.participants.options.legal_entities.label')
    default:
      return i18n.t('surveys.configuration.participants.options.all_employees.label')
  }
}
